module.exports = __webpack_public_path__ + "img/pointcard-input.5738efee.png";